import React from 'react'; // eslint-disable-line

import t from '../theme/newstyles';
import { motion } from 'framer-motion';

/** @jsxImportSource @emotion/react */

export const AddIcon = (props: Object) => {
  return (
    <motion.svg aria-labelledby="addIconTitleID" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <title id="addIconTitleID">Add Icon</title>
      <rect x="12" y="4" width="1" height="15" css={[t.fill_current]} />
      <rect x="5" y="11" width="15" height="1" css={[t.fill_current]} />
    </motion.svg>
  );
};
